<template>
  <section class="pa-section pa-section-terms">
    <div class="pa-golden-wide-box pa-terms">
      <p class="title">特定商取引に基づく表記</p>
      <div class="content pa-content pa-front-terms">
        <PATokusho />
      </div>
    </div>
  </section>
</template>

<script>
import FrontPageMixins from '@/mixins/FrontPageMixins'

import PATokusho from '@/components/Parts/PATokusho/PATokusho.vue'

export default {
  mixins : [
    FrontPageMixins
  ],

  components: {
    PATokusho
  },

  async mounted(){
    await this.initializePage({
      'asLoginedView' : false
    });
  }
}
</script>

<style lang="scss">
@import "~bulma/sass/utilities/_all";
@import "@/assets/scss/_variables.scss";

@import "@/assets/scss/mixins.scss";
@import "@/assets/scss/globals.scss";

.pa-section{
  &-terms{
    .pa-terms{
      p.title{
        font-size:1.3rem;
      }

      div.pa-content{
        font-size:1.1rem;
        padding:.5rem;

        p.update{
          text-align: right;
        }

        h4{
          margin-top:1.5rem;
        }

        &.pa-front-terms{
          .pa-vertical-table{
            background:transparent;

            .pa-column{
              .pa-title{
                border-left:4px solid #c2b090;
                border-bottom:2px solid #c2b090;
              }

              .pa-text{
                .pa-sub-mini{
                  background-color: #cfc0a5;
                }
              }

              .pa-option{
                background:#cfc0a5;
              }
            }
          }
        }
      }
    }
  }
}
</style>